export default {
    cn: {
        auditLog: {
            logDate: '记录时间：',
            typeText: '类别：',
            description: '描述：',
            modifiedID: '账号：',
            selectTimeText: '请选择日期',
            inputDefault: '请输入内容',
            searchText: '搜索',
            to: '至',
            startTime: '开始时间',
            endTime: '结束时间',
            lastWeek: '最近一周',
            lastMonth: '最近一个月',
            lastThreeMonths: '最近三个月',
            notNumber: '账号请输入数字',
            tableHead: [
                { key: 'type', value: '类别' },
                { key: 'MODIFIED_ID', value: '账号' },
                { key: 'DESCRIPTION', value: '描述' },
                { key: 'OLD_VALUE', value: '修改前的值' },
                { key: 'NEW_VALUE', value: '修改后的值' },
                { key: 'LOG_BY', value: '修改人' },
                { key: 'LOG_DATE', value: '记录时间' }
            ],
            typeMaps: { "-1": "所有", "0": "增加", "1": "修改", "2": "刪除" },
        }
    },
    hk: {
        auditLog: {
            logDate: '記錄時間：',
            typeText: '類別：',
            description: '描述：',
            modifiedID: '賬號：',
            selectTimeText: '請選擇日期',
            inputDefault: '請輸入內容',
            searchText: '搜索',
            to: '至',
            startTime: '開始時間',
            endTime: '結束時間',
            lastWeek: '最近一周',
            lastMonth: '最近一個月',
            lastThreeMonths: '最近三個月',
            notNumber: '賬號請輸入數字',
            tableHead: [
                { key: 'type', value: '類別' },
                { key: 'MODIFIED_ID', value: '賬號' },
                { key: 'DESCRIPTION', value: '描述' },
                { key: 'OLD_VALUE', value: '修改前的值' },
                { key: 'NEW_VALUE', value: '修改後的值' },
                { key: 'LOG_BY', value: '修改人' },
                { key: 'LOG_DATE', value: '記錄時間' }
            ],
            typeMaps: { "-1": "所有", "0": "增加", "1": "修改", "2": "刪除" },
        }
    },
    en: {
        auditLog: {
            logDate: 'Log Date：',
            typeText: 'Type：',
            description: 'Description：',
            modifiedID: 'Modified ID：',
            selectTimeText: 'Pleaese Select Date',
            inputDefault: 'Pleaese Input Text',
            searchText: 'Search',
            to: 'to',
            startTime: 'Start Time',
            endTime: 'End Time',
            lastWeek: 'Last Week',
            lastMonth: 'Last Month',
            lastThreeMonths: 'Last Three Months',
            notNumber: 'Modified ID Must Be Number',
            tableHead: [
                { key: 'type', value: 'Type' },
                { key: 'MODIFIED_ID', value: 'Modified ID' },
                { key: 'DESCRIPTION', value: 'Description' },
                { key: 'OLD_VALUE', value: 'Old Value' },
                { key: 'NEW_VALUE', value: 'New Value' },
                { key: 'LOG_BY', value: 'Log By' },
                { key: 'LOG_DATE', value: 'Log Date' }
            ],
            typeMaps: { "-1": "All", "0": "Add", "1": "Update", "2": "Delete" },
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/auditLog.js